import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';

const BASE_URL = `${API_URL}/bibliographic-alert`
const BibliographicAlertRequest = () => {
    return {
        getReportCards(){
            return BaseRequest.axiosInst.get(
                `${BASE_URL}/get-report-cards`,
                { headers: BaseRequest.publicHeaders() },
            );
        },
        getReportCardData(cod_report_card){
            return BaseRequest.axiosInst.get(
                `${BASE_URL}/get-report-card-data`,
                {
                    headers: BaseRequest.publicHeaders(),
                    params: {cod_report_card}
                },
            );
        },
        getReportCardDataItem(cod_report_card, chapter_code){
            return BaseRequest.axiosInst.get(
                `${BASE_URL}/get-report-card-data-item`,
                {
                    headers: BaseRequest.publicHeaders(),
                    params: {cod_report_card, chapter_code}
                },
            );
        },
    }
}

export default BibliographicAlertRequest();
